import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { localVerticalHead } from "@/config/seoLocal";
import { redirectLegacyMunicipality } from "@/lib/legacyRedirects";
import { assertServiceSlug } from "@/lib/slugGuards";
import { localFactsLoader } from "@/lib/localFactsLoader";

const ServiceSlugPage = lazy(() => import("@/pages/produkter/ServiceSlugPage"));

export const Route = createFileRoute("/laddstolpar/$slug")({
  beforeLoad: ({ params }) => {
    redirectLegacyMunicipality("laddstolpar", params.slug);
  },
  // Kommun eller produkt – annars riktig 404.
  loader: async ({ params }) => {
    await assertServiceSlug("laddstolpar", params.slug, { municipalityPages: true });
    // Kommunsidor: lokala fakta (elområde, spotpris, nätägare) i server-HTML:en.
    return { localFacts: await localFactsLoader(params.slug) };
  },
  head: ({ params, loaderData }) => localVerticalHead("laddstolpar", params.slug, {}, loaderData?.localFacts),
  component: () => <ServiceSlugPage vertical="laddstolpar" />,
});
